import React from "react";
import { Outlet } from "react-router-dom";
import LandingNav from "./LandingNav";
import Footer from "./Footer";

export default function LandingLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <LandingNav />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
